var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M720-80v-120H600v-40h120v-120h40v120h120v40H760v120h-40ZM129.23-180v-240H80v-40l46.154-200h547.692L720-460v40h-49.231v130.769h-40V-420H449.231v240H129.23Zm40.001-40H409.23v-200H169.231v200Zm-48.769-240h559.076-559.076Zm5.692-280v-40h547.692v40H126.154Zm-5.692 280h559.076l-37.077-160H157.538l-37.076 160Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessList);
export default __webpack_public_path__ + "static/media/business-list.f9c7a134d79363b29409ab3b4762a724.svg";
export { ForwardRef as ReactComponent };